import axios from "axios";
import { API_BASE_URL } from "../config/apiConfig";

export const sendOtp = async (correo) => {
  const response = await axios.post(`${API_BASE_URL}/auth/forgotPassword`, { correo });
  return response.data;
};

export const verifyOtp = async (correo, otp) => {
  const response = await axios.post(`${API_BASE_URL}/auth/verifyOtp`, { correo, otp });
  return response.data;
};

export const resetPassword = async (correo, newPassword) => {
  const response = await axios.post(`${API_BASE_URL}/auth/resetPassword`, {
    correo,
    newPassword,
  });
  return response.data;
};
